import React, { createContext, useState, useContext, useMemo } from 'react';

interface CountryContextType {
  country: string;
  setCountry: (country: string) => void;
  availableCountries: { code: string; name: string; flag: string }[];
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // FIXED: Removed localStorage - just use state with default value
  const [country, setCountryState] = useState('IN');

  const setCountry = (newCountry: string) => {
    setCountryState(newCountry);
    // Navigate to home page for consistent UX after changing country
    window.location.hash = '/';
  };

  const availableCountries = useMemo(() => [
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'US', name: 'United States', flag: '🇺🇸' },
    { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  ], []);

  return (
    <CountryContext.Provider value={{ country, setCountry, availableCountries }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = (): CountryContextType => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};